module.exports = __webpack_public_path__ + "static/media/ogwugo-white-logo.d0fc64ae.svg";